import React from "react";
import { WidgetProps } from "./types";
import Motivation from "./dtlyl/Motivation";
import QuadrantsDeconstruction from "./dtlyl/QuadrantsDeconstruction";
import QuadrantsReconstruction from "./dtlyl/QuadrantsReconstruction";
import WordsThatMatter from "./dtlyl/WordsThatMatter";
import TooMuchTooLittle from "./dtlyl/TooMuchTooLittle";
import FromTodayToTomorrow from "./dtlyl/FromTodayToTomorrow";
import HeroesDiscovery from "./dtlyl/HeroesDiscovery";
import HeroesReveal from "./dtlyl/HeroesReveal";
import MetaphorsForLife from "./dtlyl/MetaphorsForLife";
import Insight from "./dtlyl/Insight";
import ExpressionTask from "./dtlyl/ExpressionTask";
import Letter from "./dtlyl/Letter";
import LifeMap from "./dtlyl/LifeMap";
import Reflection from "./dtlyl/Reflection";
import ActionablePlan from "./dtlyl/ActionablePlan";

/**
 * Widget key -> component. The only place a widget key appears in the frontend.
 *
 * Keys must match Interactive::Manifest on the Ruby side. A key with no entry
 * here renders nothing and reports to Honeybadger — see Interactive/index.tsx.
 */
const WIDGETS: Record<string, React.FC<WidgetProps>> = {
  "dtlyl/motivation": Motivation,
  // One component, three questions — see Interactive::DTLYL::Reflection.
  "dtlyl/reflection_deconstruction": Reflection,
  "dtlyl/reflection_perspective": Reflection,
  "dtlyl/reflection_metaphors": Reflection,
  "dtlyl/quadrants_deconstruction": QuadrantsDeconstruction,
  "dtlyl/too_much_too_little": TooMuchTooLittle,
  "dtlyl/heroes_discovery": HeroesDiscovery,
  "dtlyl/heroes_reveal": HeroesReveal,
  "dtlyl/metaphors_for_life": MetaphorsForLife,
  "dtlyl/insight": Insight,
  "dtlyl/from_today_to_tomorrow": FromTodayToTomorrow,
  "dtlyl/words_that_matter": WordsThatMatter,
  "dtlyl/quadrants_reconstruction": QuadrantsReconstruction,
  "dtlyl/expression_task": ExpressionTask,
  "dtlyl/letter": Letter,
  "dtlyl/actionable_plan": ActionablePlan,
  "dtlyl/life_map": LifeMap,
};

export default WIDGETS;
